var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test"},[_c('Treant',{attrs:{"tree":_vm.tree,"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }